import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlarmFieldSpeedingComponent } from './alarm-field-speeding.component';
import { FieldNumberModule, FieldSelectModule } from '@mri/app/modules';



@NgModule({
  declarations: [
    AlarmFieldSpeedingComponent
  ],
  exports: [
    AlarmFieldSpeedingComponent
  ],
  imports: [
    CommonModule,
    FieldSelectModule,
    FieldNumberModule
  ]
})
export class AlarmFieldSpeedingModule { }
